import {Alert} from '@mui/material'
import React from 'react'
import {useGenerateSerialNumbersQuery} from '../../../generated/graphql'
import {Box} from '../../../webui/Box'
import {TextField} from '../../../webui/inputs/TextField'

export const BoxGenerateSerialNumbersPage: React.FC = () => {
  // no-cache so each visit shows freshly generated serial numbers
  const {data, loading, error} = useGenerateSerialNumbersQuery({fetchPolicy: 'no-cache'})

  if (loading) {
    return <Box m={2}>Loading…</Box>
  }
  if (error) {
    return <Box m={2}>{error.message}</Box>
  }

  const serialNumbers = data?.box?.generateSerialNumbers ?? []

  return (
    <Box m={2}>
      <Box mb={2}>
        <Alert severity="info">
          These are 100% valid serial numbers — correct format and checksum, ready to assign. They are freshly generated and not yet linked to any
          box; reload the page to generate a new set.
        </Alert>
      </Box>
      <TextField
        id="generated-serial-numbers"
        label="Generated serial numbers"
        value={serialNumbers.join('\n')}
        multiline
        width={260}
        InputProps={{readOnly: true}}
      />
    </Box>
  )
}
